class TaskPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task._m';

    // Access scope - ALL: Can access all tasks
    static ACCESS_SCOPE_ALL = 'task.access.scope.all';

    // Access scope - PARTICIPANT: Can access only tasks, where assigned as a participant
    static ACCESS_SCOPE_PARTICIPANT = 'task.access.scope.participant';

    // Access scope - WORKSPACE: Can access only tasks, where owner is in same workspace
    static ACCESS_SCOPE_WORKSPACE = 'task.access.scope.workspace';

    // Access scope - OWNER: Can access only owned tasks
    static ACCESS_SCOPE_OWNER = 'task.access.scope.owner';

    // Can access archived tasks
    static ACCESS_ARCHIVE = 'task.access.archive';

    // Can create draft tasks
    static CREATE_DRAFT = 'task.create.draft';

    // Can update task brief when task is unpublished
    static BRIEF_UPDATE_UNPUBLISHED = 'task.brief.update.unpublished';

    // Can update task brief at any state
    static BRIEF_UPDATE_PUBLISHED = 'task.brief.update.published';

    // Can update published task brief if assigned as participants
    static BRIEF_UPDATE_PUBLISHED_MOD_ASSIGNED = 'task.brief.update.published.mod.assigned';

    // Can set/update/remove deadline
    static DEADLINE_MANAGE = 'task.deadline.manage';

    // Can manage deadline if assigned as participant
    static DEADLINE_MANAGE_MOD_ASSIGNED = 'task.deadline.manage.mod.assigned';

    // Can pause/resume task
    static PAUSE_MANAGE = 'task.pause.manage';

    // Can manage pause state if assigned as participant
    static PAUSE_MANAGE_MOD_ASSIGNED = 'task.pause.manage.mod.assigned';

    // Can join task as a participant
    static PARTICIPATION_JOIN = 'task.participation.join';

    // Can assign/remove participants of the task
    static PARTICIPATION_MANAGE = 'task.participation.manage';

    // Can manage participants if assigned as participant
    static PARTICIPATION_MANAGE_MOD_ASSIGNED = 'task.participation.manage.mod.assigned';

    // Can manage task priority elevation
    static PRIORITY_MANAGE = 'task.priority.manage';

    // Can manage task priority if assigned as participant
    static PRIORITY_MANAGE_MOD_ASSIGNED = 'task.priority.manage.mod.assigned';

    // Can manage complexity settings
    static COMPLEXITY_MANAGE = 'task.complexity.manage';

    // Can manage complexity if assigned as a participant
    static COMPLEXITY_MANAGE_MOD_ASSIGNED = 'task.complexity.manage.mod.assigned';

    // Can transition task state
    static STATE_TRANSITION = 'task.state.transition';

    // Can transition task state if assigned as participant
    static STATE_TRANSITION_MOD_ASSIGNED = 'task.state.transition.mod.assigned';

    // Can transition to state: PICKUP_READY
    static STATE_TRANSITION_PICKUP_READY = 'task.state.transition.pickup_ready';

    // Can transition to state: IN_PROGRESS
    static STATE_TRANSITION_IN_PROGRESS = 'task.state.transition.in_progress';

    // Can transition to state: INTERNAL_QA
    static STATE_TRANSITION_INTERNAL_QA = 'task.state.transition.internal_qa';

    // Can transition to state: CLIENT_REVIEW
    static STATE_TRANSITION_CLIENT_REVIEW = 'task.state.transition.client_review';

    // Can transition to state: REVISION_REQUIRED
    static STATE_TRANSITION_REVISION_REQUIRED = 'task.state.transition.revision_required';

    // Can transition to state: IN_REVISION
    static STATE_TRANSITION_IN_REVISION = 'task.state.transition.in_revision';

    // Can transition to state: PRE_DELIVERED
    static STATE_TRANSITION_PRE_DELIVERED = 'task.state.transition.pre_delivered';

    // Can transition to state: DELIVERED
    static STATE_TRANSITION_DELIVERED = 'task.state.transition.delivered';

    // Can archive task
    static ARCHIVE = 'task.archive';

    // Can restore archived task
    static RESTORE = 'task.restore';

    // Can reopen task
    static REOPEN = 'task.reopen';

    // Can reopen request if assigned as a participant
    static REOPEN_MOD_ASSIGNED = 'task.reopen.mod.assigned';

    // Can lock/unlock task queue automation
    static QUEUE_LOCK_MANAGE = 'task.queue.lock.manage';

    // Can change task queue position
    static QUEUE_POSITION_MANAGE = 'task.queue.position.manage';

    // Can manually transition task queue
    static QUEUE_TRANSITION = 'task.queue.transition';

    // Can attempt swapping 2 tasks
    static QUEUE_SWAP = 'task.queue.swap';
}

export default TaskPermission;
